/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var MutationObserver = window.MutationObserver
  || window.WebKitMutationObserver
  || window.MozMutationObserver;

/**
 * Создает новый MutationObserver.
 * @param {Node} node Отслеживаемый узел.
 * @param {Object} config Конфигурация.
 * @param {Function} callback Сработает при изменении узла.
 * @returns {MutationObserver} Новый MutationObserver.
 */
app.helpers.MutationObserver = function (node, config, callback) {
  var mutationObserver = new MutationObserver(callback);
  mutationObserver.observe(node, config);
  return mutationObserver;
};

}.call(window));